export default __webpack_public_path__ + "static/media/015-skull-and-bones.46001e92.png";